<template>
  <!-- 招聘岗位详情页 -->
  <div class="detail-container">
    <div class="page-header">
      <el-button type="text" class="back-btn" @click="goBack">
        <i class="el-icon-arrow-left"></i> 返回列表
      </el-button>
    </div>
    <div class="detail-content" v-if="jobDetail">
      <h1 class="job-title">{{ jobDetail.postName }}</h1>
      <div class="salary">{{ jobDetail.salary }}</div>

      <div class="basic-info">
        <div class="info-item">
          <span class="label">最低学历：</span>
          <span class="value">{{ jobDetail.education || '不限' }}</span>
        </div>
        <div class="info-item ">
          <span class="label ">招聘人数：</span>
          <span class="value">{{ jobDetail.peopleNum || 2 }} 人</span>
        </div>
        <div class="info-item">
          <span class="label">经验要求：</span>
          <span class="value">{{ jobDetail.workYear || '不限' }}</span>
        </div>
        <div class="info-item ">
          <span class="label">工作地区：</span>
          <span class="value">{{ jobDetail.workAddress }}</span>
        </div>
      </div>

      <div class="message" style="font-size: 18px" v-if="jobDetail.message">{{ jobDetail.message }}</div>
      <div class="section">
        <h2 class="subtitle">{{ jobDetail.subTitle }}</h2>
        <h2 class="section-title">【职位描述】</h2>
        <ul class="duty-list">
          <li v-for="(duty, index) in jobDetail.workContent" :key="'duty' + index">{{ duty }}</li>
        </ul>
      </div>

      <div class="section">
        <h2 class="section-title">【任职要求】</h2>
        <ul class="requirement-list">
          <li v-for="(requirement, index) in jobDetail.workRequirements" :key="'req' + index">{{ requirement }}</li>
        </ul>
      </div>

      <div class="section" v-if="jobDetail.companyBenefits && jobDetail.companyBenefits.length">
        <h2 class="section-title">【公司福利】</h2>
        <ul class="benefits-list">
          <li v-for="(benefit, index) in jobDetail.companyBenefits" :key="'benefit' + index">{{ benefit }}</li>
        </ul>
      </div>


      <div class="section" v-if="jobDetail.workContent_2 && jobDetail.workContent_2.length">
        <h2 class="subtitle">{{ jobDetail.subTitle_2 }}</h2>
        <h2 class="section-title">【职位描述】</h2>
        <ul class="benefits-list">
          <li v-for="(benefit, index) in jobDetail.workContent_2" :key="'benefit' + index">{{ benefit }}</li>
        </ul>
      </div>

       <div class="section" v-if="jobDetail.workRequirements_2 && jobDetail.workRequirements_2.length">
        <h2 class="section-title">【任职要求】</h2>
        <ul class="requirement-list">
          <li v-for="(requirement, index) in jobDetail.workRequirements_2" :key="'req' + index">{{ requirement }}</li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailPage',
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      jobDetail: null
    }
  },
  created() {
    // 数据源会通过动态路由的meta配置自动注入
    const dataSource = this.$route.meta.dataSource
    this.getJobDetail(dataSource)
  },
  methods: {
    getJobDetail(dataSource) {
      if (!dataSource) {
        this.$message.error('数据源不存在')
        return this.$router.push('/join/recruit')
      }

      this.jobDetail = dataSource.find(item => item.id === Number(this.id))
      if (!this.jobDetail) {
        this.$message.error('职位信息不存在')
        this.$router.push('/join/recruit')
      }
    },
    goBack() {
      this.$router.push('/join/recruit')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  min-height: calc(100vh - 200px);

  .detail-content {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .job-title {
    font-size: 24px;
    color: #333;
    margin-bottom: 15px;
  }

  .salary {
    font-size: 20px;
    color: #f56c6c;
    margin-bottom: 20px;
  }

  .basic-info {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 30px;
    font-size: 16px;
    overflow: hidden;

    .info-item {
      display: flex;
      align-items: center;
      padding: 20px 15px;
      margin-bottom: 0;
      transition: background-color 0.3s;

      &:nth-child(odd) {
        background-color: #fafafa;
      }

      &:nth-child(even) {
        background-color: #f5f5f5;
      }

      .label {
        color: rgba(102, 102, 102, 1);
        margin-right: 10px;
        width: 80px;
      }

      .value {
        color: #606266;
        flex: 1;
      }
    }
  }

  .section {
    margin-bottom: 30px;

    .subtitle {
      text-align: center;
      margin: 100px auto 20px;
    }

    .section-title {
      font-size: 18px;
      color: #303133;
      margin-bottom: 15px;
      font-weight: bold;
    }
    .duty-list, .requirement-list, .benefits-list {
      font-size: 16px;
    }

    ul {
      list-style: none;
      padding-left: 0;

      li {
        color: #606266;
        line-height: 1.8;
        margin-bottom: 10px;
        padding-left: 15px;
        position: relative;

        &:before {
          content: "";
          width: 6px;
          height: 6px;
          background: #409EFF;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 10px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .detail-container {
    padding: 10px;

    .detail-content {
      padding: 15px;
    }

    .basic-info {
      .info-item {
        padding: 10px 15px;

        .label {
          width: 70px;
        }
      }
    }
  }
}
</style>
